import { z } from 'zod';
import { BaseFlowBlockSchema } from '../../block.js';
import { FlowBlockType } from '../../type.js';
export const FlowOcrBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Ocr),
    config: z.object({
        gsPaths: z.string(),
        fileReference: z.string().optional(),
    }),
});
//# sourceMappingURL=config.js.map